import React from 'react';

interface BoardToolbarProps {
  search: string;
  setSearch: (val: string) => void;
  tags: string[];
  selectedTag: string;
  setSelectedTag: (val: string) => void;
  onExport: () => void;
  realtime: boolean;
  setRealtime: (val: boolean) => void;
}

export const BoardToolbar: React.FC<BoardToolbarProps> = ({
  search,
  setSearch,
  tags,
  selectedTag,
  setSelectedTag,
  onExport,
  realtime,
  setRealtime,
}) => {
  return (
    <div className="flex gap-2 items-center mb-4">
      <input
        type="text"
        placeholder="Search cards..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        className="border rounded px-2 py-1"
      />
      <select
        value={selectedTag}
        onChange={e => setSelectedTag(e.target.value)}
        className="border rounded px-2 py-1"
      >
        <option value="">All Tags</option>
        {tags.map(tag => <option key={tag} value={tag}>{tag}</option>)}
      </select>
      <button className="btn btn-sm" onClick={onExport}>Export Board</button>
      
      {/* Real-time toggle */}
      <div className="flex items-center gap-2 ml-auto">
        <label className="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            checked={realtime}
            onChange={e => setRealtime(e.target.checked)}
            className="w-4 h-4"
          />
          <span className="text-xs text-gray-600">
            Real-time updates (higher quota)
          </span>
        </label>
      </div>
    </div>
  );
}; 